
































































































import { Component, Vue } from 'vue-property-decorator';
import WithdrawMethod from './models/WithdrawMethod';

@Component({
    components: {
    },
})
export default class Withdraw extends Vue {
    private witdrawMethods: WithdrawMethod[] = [
        {
            image: require('../../assets/images/bank.png'),
            title: 'Bank Transfer',
            link: '/withdraw',
        }, {
            image: require('../../assets/images/paypal.png'),
            title: 'Paypal account',
            link: '/withdraw/paypal',
        }
    ];

    get selectedTab() {
        return this.$route.path
    }
}
